import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Icon,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  triggerBtn: {
    padding: 4,
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 1,
};

export default function ConstructorBlockDialog(props) {
  const classes = useStyles();
  const { blockId, blockTitle } = props;
  const [open, setOpen] = useState(false);

  const toggleDialog = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <IconButton className={classes.triggerBtn} onClick={toggleDialog}>
        <Icon className="fab fa-dev" style={commonIcon} />
      </IconButton>
      <Dialog open={open} maxWidth="sm" fullWidth onClose={toggleDialog}>
        <DialogTitle
          id={`${blockId}-constructor-dialog-title`}
          disableTypography
          className={classes.dialogTitle}
        >
          <Typography variant="h6">{blockTitle}</Typography>
          <IconButton onClick={toggleDialog}>
            <Icon className="fas fa-times" />
          </IconButton>
        </DialogTitle>
      </Dialog>
    </>
  );
}
